module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 let categoryOpen = isOpen || false; ;
__p += '\n';
 _.forEach( category.children, function( node ) {;
__p += '\n	';
 if ( node.ancestor || node.current ) { ;
__p += '\n		';
 categoryOpen = true; ;
__p += '\n	';
 } ;
__p += '\n';
 } ) ;
__p += '\n\n';
 _.forEach( category.children, function( node, index ) {
    const isActive = node.ancestor || node.current || ! categoryOpen;
;
__p += '\n	<li class="facet_menu__item' +
((__t = ( node.ancestor ? ' facet_menu__item--current_ancestor' : '' )) == null ? '' : __t) +
'' +
((__t = ( node.current ? ' facet_menu__item--current' : '' )) == null ? '' : __t) +
'\n	' +
((__t = ( node.children.length > 0 ? ' facet_menu__item--has_submenu' + (isActive ? ' active_scope' : '') : '' )) == null ? '' : __t) +
'"\n		role="treeitem" aria-selected="' +
((__t = ( node.current ? 'true' : 'false' )) == null ? '' : __t) +
'" ';
 if ( node.children.length > 0 ) { ;
__p += ' aria-expanded="' +
((__t = ( isActive ? 'true' : 'false' )) == null ? '' : __t) +
'"';
 } ;
__p += '>\n		<a href="/' +
((__t = ( node.customfield1 )) == null ? '' : __t) +
'" class="facet_menu__item_name">\n			';
 if ( node.current || node.ancestor ) { ;
__p += '\n			<span class="en-item-title">' +
((__t = ( node.name )) == null ? '' : __t) +
'</span>\n			';
 } else { ;
__p += '\n			' +
((__t = ( node.name )) == null ? '' : __t) +
'\n			';
 } ;
__p += '\n		</a>\n		';
 if ( node.children.length > 0 ) { ;
__p += '\n		<button type="button" class="facet_menu__item_button' +
((__t = ( isActive ? ' active' : '' )) == null ? '' : __t) +
'"></button>\n		<ul class="facet_menu facet_menu--sub facet_menu--level_' +
((__t = ( node.level )) == null ? '' : __t) +
'' +
((__t = ( isActive ? ' active' : '' )) == null ? '' : __t) +
'" style="' +
((__t = ( ! categoryOpen ? 'display:block' : '')) == null ? '' : __t) +
'" role="group">\n			<li class="facet_menu__item en-filter-all" role="treeitem" aria-selected="false">\n				<a href="/' +
((__t = ( node.customfield1 )) == null ? '' : __t) +
'"\n				   class="facet_menu__item_name"><span class="en-item-title">Alle anzeigen</span></a>\n			</li>\n			';
 if ( ! categoryOpen ) { categoryOpen = true } ;
__p += '\n			' +
((__t = ( renderSelf( { 'category': node, renderSelf, isOpen: categoryOpen } ) )) == null ? '' : __t) +
'\n		</ul>\n		';
 } ;
__p += '\n	</li>\n';
 }) ;
__p += '\n';

}
return __p
};
